<bit-dialog #dialog dialogSize="large" background="default" class="bv-send-dialog">
  <span bitDialogTitle>
    {{ headerText() | i18n }}
  </span>
  <span bitDialogContent>
    @if (showGenerator()) {
      <vault-cipher-form-generator
        type="password"
        (valueGenerated)="onValueGenerated($event)"
        (algorithmSelected)="onAlgorithmSelected($event)"
        disableMargin
      ></vault-cipher-form-generator>
    }
    <div [hidden]="showGenerator()">
      @if (disabledSendConfig()) {
        <bit-callout type="info" [title]="disabledSendConfig().title | i18n">
          <div>{{ disabledSendConfig().message | i18n }}</div>
          @if (disabledSendConfig().showMakeCopyButton) {
            <button
              class="tw-mt-4"
              type="button"
              bitButton
              buttonType="primary"
              (click)="makeCopy()"
            >
              {{ "makeACopy" | i18n }}
            </button>
          }
        </bit-callout>
      }
      @if (config()) {
        <app-bv-send-form
          formId="sendForm"
          [config]="config()!"
          (onSendCreated)="onSendCreated($event)"
          (onSendUpdated)="onSendUpdated($event)"
          (openPasswordGenerator)="openGenerator()"
          [editing]="editing()"
          [submitBtn]="submitBtn()"
        >
        </app-bv-send-form>
      }
    </div>
  </span>

  <ng-container bitDialogFooter>
    @if (showGenerator()) {
      <button
        type="button"
        bitButton
        buttonType="primary"
        (click)="useGeneratedPassword()"
        [disabled]="!(generatorButtonLabel() && generatedValue())"
      >
        {{ generatorButtonLabel() }}
      </button>
      <button bitButton type="button" buttonType="secondary" (click)="closeGenerator()">
        {{ "cancel" | i18n }}
      </button>
    } @else {
      @if (disabledSendConfig()) {
        @if (disabledSendConfig().showMakeCopyButton) {
          <button type="button" bitButton buttonType="primary" (click)="makeCopy()">
            {{ "makeACopy" | i18n }}
          </button>
          <div class="tw-ml-auto">
            <button
              type="button"
              buttonType="dangerGhost"
              bitIconButton="bwi-trash"
              [bitAction]="deleteSend"
              label="{{ 'delete' | i18n }}"
            ></button>
          </div>
        } @else {
          <button type="button" bitButton buttonType="danger" [bitAction]="deleteSend">
            {{ "delete" | i18n }}
          </button>
        }
      } @else {
        <div class="bv-send-dialog__footer">
          <div class="bv-send-dialog__footer-start">
            <button
              type="button"
              class="bv-send-dialog__icon-btn bv-send-dialog__icon-btn--danger"
              bitIconButton="bwi-trash"
              [bitAction]="config()?.mode === 'add' ? cancelEditSendAction : deleteSend"
              [label]="config()?.mode === 'add' ? ('cancel' | i18n) : ('delete' | i18n)"
            ></button>
            <button
              type="button"
              class="bv-send-dialog__icon-btn bv-send-dialog__icon-btn--star"
              [class.bv-send-dialog__icon-btn--star-active]="isFavorite() || favoritePending()"
              [bitIconButton]="favoriteIcon()"
              (click)="toggleFavorite()"
              [label]="(isFavorite() || favoritePending() ? 'unfavorite' : 'favorite') | i18n"
            ></button>
          </div>
          <div class="bv-send-dialog__footer-end">
            @if (editing()) {
              <button
                bitButton
                type="button"
                buttonType="secondary"
                class="bv-send-dialog__cancel-btn"
                (click)="cancelEditSend()"
              >
                {{ "cancel" | i18n }}
              </button>
              <button bitButton type="submit" form="sendForm" buttonType="primary" #submitBtn>
                {{ "save" | i18n }}
              </button>
            } @else {
              <button bitButton type="button" buttonType="secondary" (click)="editSend()">
                {{ "edit" | i18n }}
              </button>
            }
          </div>
        </div>
      }
    }
  </ng-container>
</bit-dialog>
